import React from 'react'
import { Column, Row } from 'components/common/layout'
import { ModalContent } from 'components/scouts/common/styles'
import { BtnSize, BtnType, Button } from 'components/common/button'
import { Modal } from 'components/common/modal'
import { usePreAnalysis, useRequestFormOptions } from 'apis/hooks'
import { ExpectedProposal } from 'components/scouts/request-form/condition/expected-proposal'
import { PreAnalysis } from 'components/scouts/request-form/condition/pre-analysis'
import { User } from 'types/common'
import styled from 'styled-components'
import { useIsDesktopCSR } from 'utils/hooks'
import { useRouter } from 'next/router'
import { RoutePaths, RouterQueryKey } from 'types/router'
import { getQueryUrl } from 'utils/formatters'
import { useStores } from 'stores/globals'

export const ConditionLaterModal: React.FC<{
  user: User
  onClose: () => void
}> = ({ user, onClose }) => {
  const isDesktop = useIsDesktopCSR()
  const { data: preAnalysis } = usePreAnalysis({
    positions: user.interestedPositionTypes.map((position) => position.id),
    experience: user.experience,
  })
  const { data: options } = useRequestFormOptions()
  const { applyModalStore, scoutConditionFormStore } = useStores()
  const router = useRouter()
  const fromSite = router.query[RouterQueryKey.FROM_SITE]
  const startupId = Number(router.query[RouterQueryKey.STARTUP_ID]) || undefined
  const positionId =
    Number(router.query[RouterQueryKey.POSITION_ID]) || undefined
  if (!preAnalysis || !options) return null
  return (
    <Modal width={630} onClose={onClose} disableCloseBtn>
      <Column style={{ maxHeight: 730, justifyContent: 'start' }}>
        <ModalContent>
          <PreAnalysis user={user} preAnalysis={preAnalysis} />
          <ExpectedProposal user={user} options={options} />
        </ModalContent>
        <BtnWrapper>
          <CtaBtn
            variant={BtnType.SUPER_LOW}
            size={!isDesktop ? BtnSize.MEDIUM : undefined}
            style={{ flex: 1 }}
            onClick={() => {
              if (startupId && positionId) {
                // 예외1. 지원하다가 넘어왔을 때 => 보던 지원 플로우
                const url = isDesktop
                  ? RoutePaths.POSITIONS
                  : getQueryUrl({
                      pathname: RoutePaths.POSITION_APPLICATION,
                      query: {
                        [RouterQueryKey.STARTUP_ID]: String(startupId),
                        [RouterQueryKey.POSITION_ID]: String(positionId),
                      },
                    })
                router.push(url)
                if (isDesktop) applyModalStore.openModal(positionId, startupId)
              } else if (
                typeof fromSite === 'string' &&
                fromSite.includes('positions')
              ) {
                // 예외2. 채용 공고 쪽에서 넘어왔을 때 => 채용 공고
                router.push('/positions')
              } else {
                // 기본. 내 프로필 페이지로 이동
                router.push({
                  pathname: RoutePaths.MY_PROFILE,
                  query: { [RouterQueryKey.IS_FROM_REQUEST_FORM]: 'true' },
                })
              }
              scoutConditionFormStore.setHasMovedToLastSavedStep(false) // 이탈할 때 hasMovedToLastSavedStep 값 초기화
              onClose()
            }}
          >
            나중에 하기
          </CtaBtn>
          <CtaBtn
            style={{ flex: 3 }}
            onClick={onClose}
            size={!isDesktop ? BtnSize.MEDIUM : undefined}
          >
            프로필 등록 계속하기
          </CtaBtn>
        </BtnWrapper>
      </Column>
    </Modal>
  )
}

const BtnWrapper = styled(Row)`
  bottom: 0;
  position: sticky;
`

const CtaBtn = styled(Button)`
  border-radius: 0;
  padding: 16px;
`
